var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',_vm._g(_vm._b({attrs:{"active-color":_vm.activeColor,"inactive-color":_vm.inactiveColor}},'el-switch',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }